module.exports = __webpack_public_path__ + "img/imda-white.42a58862.png";